<template>

<app-input-wrapper :slim="slim" :value="value" :note="note" :label="label" :errored="errored" :class="{'is-expanded': is.expanded}">

	<div class="input-value" v-on:click="onValueClick">{{ valueText }}</div>

	<div class="input-options" v-if="is.expanded">

		<div class="input-options-item" v-for="(text, key) in options" :key="key" v-on:click="onOptionClick(key)">{{ text }}</div>

	</div>

	<app-icon name="caret" class="input-icon" />

</app-input-wrapper>

</template>

<script>

import mixinInput from '@/mixin/input.js'

export default {

	mixins: [mixinInput],

	props: ['options'],

	data: function() {

		return {
			is: {
				expanded: false
			}
		}

	},

	computed: {

		valueText: function() {

			return (this.value) ? this.options[this.value] : this.placeholder

		}

	},

	methods: {

		onValueClick: function() {

			this.is.expanded = !this.is.expanded

		},

		onOptionClick: function(value) {

			this.onValueChange(value)
			this.is.expanded = false

		}

	}

}

</script>

<style scoped>

.input-value {
	border: 1px solid var(--color-grey-light);
	width: 100%;
	height: 40px;
	border-radius: 4px;
	cursor: pointer;
	width: 100%;
	line-height: 38px;
	font-size: 14px;
	color: var(--color-grey);
	font-weight: 300;
	padding: 0px 10px;
	transition: all 100ms linear;
}

.is-desktop .input.is-expanded .input-value,
.is-desktop .input-value:hover {
	border-color: var(--color-grey-highlight);
}

.input.is-expanded .input-value {
	border-radius: 4px 4px 0px 0px;
}

.input.has-value .input-value {
	color: var(--color-grey-dark);
}

.input-options {
	position: absolute;
	top: 40px;
	width: 100%;
	margin-top: -1px;
	background-color: #fff;
	border-radius: 0px 0px 4px 4px;
	z-index: 2;
	border: 1px solid var(--color-grey-highlight);
	max-height: 170px;
    overflow-y: auto;
}

.input-options-item {
	font-size: 14px;
	line-height: 20px;
	padding: 5px 10px;
	color: var(--color-grey-dark);
	font-weight: 300;
	cursor: pointer;
}

.is-desktop .input-options-item:hover {
	background-color: var(--color-grey-light);
}

.input-icon {
	position: absolute;
	right: 10px;
	top: 11px;
	font-size: 16px;
	color: var(--color-grey-light);
	pointer-events: none;
}

.input.has-value .input-icon {
	color: var(--color-grey-dark);
}

</style>